import { getDataFromServer, formatParamsGet } from "../util";
import { CHANGE_SELECTED_COLUMNS } from "./types";

export const getAgentFinancialSummary = (id, startDate, endDate) => {
  const endpoint = `/reports/agents/${id}/financial-summary?startDate=${startDate}&endDate=${endDate}`;
  return getDataFromServer("GET", endpoint, null, true);
};

export const getAgentFinancialTransactions = (id, params) => {
  const strParams = formatParamsGet(params);
  const endpoint = `/reports/agents/${id}/financial-transactions` + strParams;
  return getDataFromServer("GET", endpoint, null, true);
};

export const getCurrentUserEarnings = (params) => {
  const strParams = formatParamsGet(params);
  const endpoint = "/reports/my-earnings" + strParams;
  return getDataFromServer("GET", endpoint, null, true);
};

export const getCurrentUserCommissionEarnings = (params) => {
  const strParams = formatParamsGet(params);
  const endpoint = `/reports/my-commission-earnings${strParams}`;
  return getDataFromServer("GET", endpoint, null, true);
};

export const getUserEarnings = (params, id) => {
  const strParams = formatParamsGet(params);
  const endpoint = `/reports/earnings/${id}${strParams}`;
  return getDataFromServer("GET", endpoint, null, true);
};

export const getUserCommissionEarnings = (params, id) => {
  const strParams = formatParamsGet(params);
  const endpoint = `/reports/commission-earnings/${id}${strParams}`;
  return getDataFromServer("GET", endpoint, null, true);
};

export const getUsersReport = (params) => {
  const strParams = formatParamsGet(params);
  const endpoint = `/reports/users${strParams}`;
  return getDataFromServer("GET", endpoint, null, true);
};

export const getReportsByGroup = (params) => {
  const strParams = formatParamsGet(params);
  const endpoint = `/reports/by-group${strParams}`;
  return getDataFromServer("GET", endpoint, null, true);
};

export const getContractsByAgent = (params) => {
  const strParams = formatParamsGet(params);
  const endpoint = `/reports/contracts/by-agent${strParams}`;
  return getDataFromServer("GET", endpoint, null, true);
};

export const getContractsByHierarchy = (params) => {
  const strParams = formatParamsGet(params);
  const endpoint = `/reports/contracts/by-hierarchy${strParams}`;
  return getDataFromServer("GET", endpoint, null, true);
};

export const generateAllMonthlyUserReports = () => getDataFromServer("POST", "/reports/monthly_snapshot", null, true);